import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
interface CaseStudyCardProps {
  title: string;
  description: string;
  metrics: string[];
  imageSrc: string;
  href: string;
}
export function CaseStudyCard({
  title,
  description,
  metrics,
  imageSrc,
  href
}: CaseStudyCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:translate-y-[-4px] hover:shadow-lg" data-id="element-25">
      <div className="h-48 overflow-hidden" data-id="element-26">
        <img src={imageSrc} alt={title} className="w-full h-full object-cover" data-id="element-27" />
      </div>
      <div className="p-6" data-id="element-28">
        <h3 className="text-xl font-display font-semibold text-navy-dark mb-2" data-id="element-29">
          {title}
        </h3>
        <p className="text-navy mb-4" data-id="element-30">{description}</p>
        <div className="mb-6" data-id="element-31">
          <h4 className="text-sm font-semibold text-navy-dark mb-2" data-id="element-32">
            Key Metrics:
          </h4>
          <ul className="space-y-1" data-id="element-33">
            {metrics.map((metric, index) => <li key={index} className="text-sm flex items-start" data-id="element-34">
                <span className="text-coral-dark mr-2" data-id="element-35">•</span>
                <span data-id="element-36">{metric}</span>
              </li>)}
          </ul>
        </div>
        <Button href={href} variant="outline" className="w-full flex justify-between" data-id="element-37">
          View Case Study
          <ArrowRightIcon size={18} data-id="element-38" />
        </Button>
      </div>
    </div>;
}